import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Button,
} from '@mui/material';
import { axiosMailGetCall } from 'src/services/apisCall';
import EditIcon from '@mui/icons-material/Edit';
import EmailUpdate from './EmailUpdate';

const EmailTable = () => {
  const [combinedData, setCombinedData] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);

  const totalColumns = 10;

  const cellStyle = {
    width: `${100 / totalColumns}%`,
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  };

   const fetchData = async () => {
    try {
  
      const {data}  = await axiosMailGetCall("getMailFilterDetails");
      
      const filterDetails = data?.mailRecords;

      if (!Array.isArray(filterDetails)) {
        setCombinedData([]);
        return;
      }

      const formattedData = filterDetails.map((item) => ({
        ...item,
        type: item?.type || '',
      }));

      setCombinedData(formattedData);
    } catch (error) {
      console.error('Error occurred while fetching mail filter details:', error);
    }
  };

   useEffect(() => {
    fetchData();
  }, []);


  const handleEditClick = (record) => {
    setSelectedRecord(record);
    setOpenEdit(true);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Mail Filters :
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={cellStyle}>Type</TableCell>
              <TableCell sx={cellStyle}>ID</TableCell>
              <TableCell sx={cellStyle}>Timeout</TableCell>
              <TableCell sx={cellStyle}>Disallowed Extensions</TableCell>
              <TableCell sx={cellStyle}>Default File Size</TableCell>
              <TableCell sx={cellStyle}>Allowed File Size</TableCell>
              <TableCell sx={cellStyle}>Archive Allow Encrypted</TableCell>
              <TableCell sx={cellStyle}>Archive Max Depth</TableCell>
              <TableCell sx={cellStyle}>Archive Extensions</TableCell>
              <TableCell sx={cellStyle}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {combinedData?.map((record) => (
              <TableRow key={record.id}>
                <TableCell sx={cellStyle}>{record.type}</TableCell>
                <TableCell sx={cellStyle}>{record.id}</TableCell>
                <TableCell sx={cellStyle}>{record.timeout}</TableCell>
                <TableCell sx={cellStyle}>{record.disallowed_extensions}</TableCell>
                <TableCell sx={cellStyle}>{record.default_file_size}</TableCell>
                <TableCell sx={cellStyle}>
                  {Object.entries(JSON.parse(record.allowed_file_size)).map(([key, val]) => (
                    <Box key={key}>
                      {key}: {val}
                    </Box>
                  ))}
                </TableCell>
                <TableCell sx={cellStyle}>{record.archive_allow_encrypted ? 'Yes' : 'No'}</TableCell>
                <TableCell sx={cellStyle}>{record.archive_max_depth}</TableCell>
                <TableCell sx={cellStyle}>{record.archive_extensions}</TableCell>
                <TableCell sx={cellStyle}>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    startIcon={<EditIcon />}
                    onClick={() => handleEditClick(record)}
                  >
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {selectedRecord && (
        <EmailUpdate
          open={openEdit}
          handleClose={() => setOpenEdit(false)}
          record={selectedRecord}
          onUpdate={fetchData}
        />
      )}
    </Box>
  );
};

export default EmailTable;
